// -- AUTOGENERATED --

// eslint-disable-next-line no-unused-vars
import APIUtils from '@/util/apiutil'

import Axios from 'axios'
import NETVSConfig from '@/../netvs.config'

/* eslint-disable camelcase */
/* eslint-disable quote-props */
/* eslint-disable object-curly-spacing */
/* eslint-disable array-bracket-spacing */
/* eslint-disable object-shorthand */
export default {

  createParamsList () {
    return {'old': [ ], 'new': [ 'fqdn_value', 'ou_fq_name', 'is_recursive']}
  },
  create (config, {fqdn_value_new, ou_fq_name_new, is_recursive_new = false}) {
    const params = { 'new': { 'fqdn_value': fqdn_value_new, 'ou_fq_name': ou_fq_name_new, 'is_recursive': is_recursive_new}, 'old': { }}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/dns/fqdn2ou/create`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
  deleteParamsList () {
    return {'old': [ 'fqdn_value', 'ou_fq_name'], 'new': [ ]}
  },
  delete (config, {fqdn_value_old, ou_fq_name_old}) {
    const params = { 'new': { }, 'old': { 'fqdn_value': fqdn_value_old, 'ou_fq_name': ou_fq_name_old}}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/dns/fqdn2ou/delete`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
  list (config, { is_own, gpk_list, fetch_limit, fetch_offset, is_recursive, fqdn_value_list, ou_fq_name_list, filter_params_dict, sorting_params_list }) {
    const params = APIUtils.denullify_dict({ 'is_own': is_own, 'gpk_list': (gpk_list === null) ? null : JSON.stringify(gpk_list), 'fetch_limit': fetch_limit, 'fetch_offset': fetch_offset, 'is_recursive': is_recursive, 'fqdn_value_list': (fqdn_value_list === null) ? null : JSON.stringify(fqdn_value_list), 'ou_fq_name_list': (ou_fq_name_list === null) ? null : JSON.stringify(ou_fq_name_list), 'filter_params_dict': filter_params_dict, 'sorting_params_list': (sorting_params_list === null) ? null : JSON.stringify(sorting_params_list)})
    const cnf = {}
    Object.assign(cnf, (config || {}).netdb_axios_config)
    cnf.params = params
    return Axios.get(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/dns/fqdn2ou/list`, cnf)
  // eslint-disable-next-line comma-dangle
  },
  updateParamsList () {
    return {'old': [ 'fqdn_value', 'ou_fq_name'], 'new': [ 'ou_fq_name', 'is_recursive']}
  },
  update (config, {fqdn_value_old, ou_fq_name_old, ou_fq_name_new, is_recursive_new}) {
    const params = { 'new': { 'ou_fq_name': ou_fq_name_new, 'is_recursive': is_recursive_new}, 'old': { 'fqdn_value': fqdn_value_old, 'ou_fq_name': ou_fq_name_old}}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/dns/fqdn2ou/update`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
}
